import {ReactNode} from 'react';

import {ActivitySidebarContext} from './ActivitySidebarContext';

interface ActivitySidebarProviderProps {
  children: ReactNode;
  handleToggleTab: (tabId: string) => void;
}

export function ActivitySidebarProvider(props: ActivitySidebarProviderProps) {
  return (
    <ActivitySidebarContext.Provider value={{handleToggleTab: props.handleToggleTab}}>
      {props.children}
    </ActivitySidebarContext.Provider>
  );
}
